import axios from 'axios'

export default {
    getReservations(data) {
        return axios.post(`/admin-calendar-event/admin-filter`, data)
    },

    activateMember(userId) {
        return axios.post(`/auth/impersonate`, { userId })
    },
}
